import usersettings from "./constants";

export const userSelectedDomains = (selectedDomains) => (dispatch) => {
  dispatch({
    type: usersettings.DOMAINS_USER_SELECTION,
    payload: [...selectedDomains],
  });
};
